import React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import { StyledQuestion } from './Question.styled'

const Question = ({ intlKey, instructionID, questionID, hintID }) => {
  return (
    <StyledQuestion>
      {instructionID && (
        <h1>
          <FormattedHTMLMessage
            id={intlKey + instructionID}
          />
        </h1>
      )}
      <h2>
        <FormattedHTMLMessage
          id={intlKey + questionID}
        />
      </h2>
      <h3>
        <FormattedHTMLMessage
          id={intlKey + hintID}
        />
      </h3>
    </StyledQuestion>
  )
}

export default Question
